

<!-- The first div is used as a full screen background overlay. There are a few components that use this overlay so it only needs to be added once preferably at the top of the page below the body tag. This is a usable example. -->
<div [hidden]="processingLogin">
  <svg aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1"
  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <symbol id="dds__search" viewBox="0 0 32 32">
      <title>dds__search</title>
      <path
        d="M30.306 28.988l-9.412-9.412c1.506-1.882 2.447-4.329 2.447-6.965 0.188-5.835-4.706-10.729-10.729-10.729s-10.729 4.894-10.729 10.918 4.894 10.729 10.729 10.729c2.635 0 5.082-0.941 6.965-2.635l9.412 9.412 1.318-1.318zM12.612 21.647c-4.894 0-8.847-3.953-8.847-8.847s3.953-9.035 8.847-9.035 8.847 3.953 8.847 8.847-3.953 9.035-8.847 9.035z">
      </path>
    </symbol>
    <symbol id="dds__user" viewBox="0 0 32 32">
      <title>dds__user</title>
      <path
        d="M16 17.694c-4.329 0-7.906-3.576-7.906-7.906s3.576-7.906 7.906-7.906c4.329 0 7.906 3.576 7.906 7.906 0 4.518-3.576 7.906-7.906 7.906zM16 3.953c-3.388 0-6.024 2.635-6.024 6.024s2.635 6.024 6.024 6.024c3.388 0 6.024-2.635 6.024-6.024s-2.635-6.024-6.024-6.024z">
      </path>
      <path
        d="M30.306 29.929h-28.612l0.188-0.941c0-0.376 0.941-7.718 6.588-11.482l0.565-0.376 0.565 0.376c3.576 3.2 9.224 3.2 12.8 0.188l0.565-0.376 0.565 0.376c5.835 3.765 6.588 11.106 6.588 11.482l0.188 0.753zM3.765 28.047h24.282c-0.376-1.882-1.694-6.024-5.082-8.659-4.141 3.012-9.976 3.012-14.118 0-3.388 2.635-4.518 6.776-5.082 8.659z">
      </path>
    </symbol>
    <symbol id="dds__cart" viewBox="0 0 32 32">
      <title>dds__cart</title>
      <path
        d="M30.118 7.341h-23.153l-1.506-4.894h-3.576v1.882h2.071l5.835 20.141h15.624v-1.882h-14.118l-0.941-3.2h17.318l2.447-12.047zM9.788 17.506l-2.447-8.282h20.329l-1.694 8.282h-16.188z">
      </path>
      <path
        d="M24.094 23.153c-1.694 0-3.2 1.318-3.2 3.2s1.318 3.2 3.2 3.2 3.2-1.318 3.2-3.2-1.506-3.2-3.2-3.2zM24.094 27.671c-0.753 0-1.318-0.565-1.318-1.318s0.565-1.318 1.318-1.318 1.318 0.565 1.318 1.318-0.565 1.318-1.318 1.318z">
      </path>
      <path
        d="M10.918 23.153c-1.694 0-3.2 1.318-3.2 3.2s1.318 3.2 3.2 3.2 3.2-1.318 3.2-3.2-1.506-3.2-3.2-3.2zM10.918 27.671c-0.753 0-1.318-0.565-1.318-1.318s0.565-1.318 1.318-1.318 1.318 0.565 1.318 1.318-0.565 1.318-1.318 1.318z">
      </path>
    </symbol>
    <symbol id="dds__menu-closed" viewBox="0 0 32 32">
      <title>dds__menu-closed</title>
      <path d="M5.176 6.965h21.647v2.071h-21.647v-2.071z"></path>
      <path d="M5.176 14.871h21.647v2.071h-21.647v-2.071z"></path>
      <path d="M5.176 22.965h21.647v2.071h-21.647v-2.071z"></path>
    </symbol>
  </defs>
</svg>
<div class="dds__msthd" data-toggle="dds__msthd">
  <nav class="dds__navbar dds__msthd-navbar-top">
    <div class="dds__msthd-top dds__container dds__no-gutters">

      <div class="dds__row dds__no-gutter">
        <div>
          <div class="dds__msthd-icon-ctnr dds__msthd-logo" style="cursor:default">
          <img src="./assets/image/delltech-logo-prm-wht-rgb.png" style="height: 23px;width: 182px; padding-right: 10px;" alt="Dell" aria-label="Dell" class="dds__d-none dds__d-xl-block dds__d-lg-block dds__d-md-none dds__d-sm-none">
          <a class="dds__icons dds__msthd-dell-icon dds__d-xl-none dds__d-lg-none dds__d-md-block dds__d-sm-block" aria-label="Dell logo" role="presentation"></a>
          </div>
          </div>
          <div class="dds__msthd-brand-ctnr dds__d-none dds__d-lg-block">
          <span class="dds__vertical-thick-divider-left dds__border-white">Dell Licensing Online</span>
          </div>

        <div class="dds__msthd-top-right-ctnr dds__d-flex">
          <div class="dds__msthd-top-ctnr"> <button class="dds__msthd-icon-ctnr" data-target="msthd-signin-ctnr"
              aria-label="Sign in" aria-haspopup="true" aria-expanded="false"> <svg focusable="false">
                <use xlink:href="#dds__user" />
              </svg> <span class="dds__badge dds__badge-success" hidden> <i class="dds__icons dds__check"></i> </span>
              <span class="dds__msthd-label dds__text-truncate">{{FirstName}}</span> </button>
            <div id="msthd-signin-ctnr" class="dds__msthd-ctnr dds__pb-0" role="menu">
              <div class="dds__col-sm-12 dds__col-md-12 dds__col-lg-12">
                <h3 *ngIf="RoleName && RoleName!=GuestUser">My Role: {{RoleName}} </h3>
                <i *ngIf="RoleName && RoleName!=GuestUser">{{EmailAddress}}</i>
                <div *ngIf="RoleName==GuestUser || !RoleName" class="dds__row dds__no-gutters">
                  <div class="dds__col-sm-12">
                    <a class="dds__btn dds__btn-primary dds__btn-block"
                      [attr.href]="dloUrl">Sign
                      In</a> </div>
                </div>
                <div *ngIf="RoleName && RoleName!=GuestUser " class="dds__row dds__no-gutters">
                  <div class="dds__col-sm-12"> <button class="dds__btn dds__btn-secondary dds__btn-block dds__mt-2" (click)="logout()">Sign Out</button> </div>
                </div>
                <br>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </nav>

  <div id="dds__msthd-overlay" class="dds__msthd-overlay"></div>
</div>
</div>

